import { api2 } from './ApiService';

export default class ContactService {
    
    static async get(){
        let response =  await api2.get(`/contact`)
        return response.data
    }

    static async update(information, email,facebook,lineId,phone){
        let data = {
            information: information,
            email: email,
            facebook: facebook,
            lineId: lineId,
            phone: phone
        }
        let response = await api2.post(`/api/v1/contact/update`,data)
        return response.data
    }
  
    
}


// WEBPACK FOOTER //
// ./src/service/ContactService.js